export default "__VITE_ASSET__5V89rbjO__"